export enum CouplePage {
    Story = 'story',
    Timeline = 'timeline',
    Photos = 'photos',
    Proposal = 'proposal',
}